// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"cd5b1bbc","582":"12102891","592":"b195cbb9"}[chunkId] + ".chunk.js";
};